export const SYSTEM_ORDER = ['segaMD', 'segaMS', 'snes', 'nes', 'atari2600', 'n64', 'gba', 'gb', 'nds', 'psx'];

/** Chave = window.EJS_core no EmulatorJS */
export const SYSTEMS = {
  segaMD: {
    label: 'Sega Mega Drive',
    ejsCore: 'genesis_plus_gx',
    accept: '.gen,.md,.smd,.bin,.zip,.32x,.iso,.cue',
    presets: [],
  },
  segaMS: {
    label: 'Sega Master System / Game Gear',
    ejsCore: 'genesis_plus_gx',
    accept: '.sms,.gg,.bin,.zip',
    presets: [],
  },
  snes: {
    label: 'Super Nintendo (SNES)',
    ejsCore: 'snes9x',
    accept: '.smc,.sfc,.fig,.swc,.zip,.bin',
    presets: [],
  },
  nes: {
    label: 'Nintendo (NES)',
    ejsCore: 'fceumm',
    accept: '.nes,.fds,.unf,.nsf,.zip,.bin',
    presets: [],
  },
  atari2600: {
    label: 'Atari 2600',
    ejsCore: 'stella2014',
    accept: '.a26,.bin,.zip',
    presets: [],
  },
  n64: {
    label: 'Nintendo 64',
    ejsCore: 'mupen64plus_next',
    accept: '.n64,.z64,.v64,.zip,.bin',
    presets: [],
  },
  gba: {
    label: 'Game Boy Advance',
    ejsCore: 'mgba',
    accept: '.gba,.zip,.bin',
    presets: [],
  },
  gb: {
    label: 'Game Boy / Color',
    ejsCore: 'gambatte',
    accept: '.gb,.gbc,.zip,.bin',
    presets: [],
  },
  nds: {
    label: 'Nintendo DS',
    ejsCore: 'desmume',
    accept: '.nds,.zip,.bin',
    presets: [],
  },
  psx: {
    label: 'PlayStation',
    ejsCore: 'pcsx_rearmed',
    accept: '.bin,.cue,.iso,.pbp,.chd,.img,.mdf,.zip',
    presets: [],
  },
};

/** Mapeamento Vimm system / systemCode → chave EJS */
const VIMM_TO_EJS = {
  NES: 'nes',
  SNES: 'snes',
  N64: 'n64',
  GBA: 'gba',
  GBC: 'gb',
  GB: 'gb',
  NDS: 'nds',
  DS: 'nds',
  GEN: 'segaMD',
  MD: 'segaMD',
  SMS: 'segaMS',
  GG: 'segaMS',
  PSX: 'psx',
  PS1: 'psx',
  PS: 'psx',
  A26: 'atari2600',
  '2600': 'atari2600',
  ATARI2600: 'atari2600',
  '3DS': '3ds',
  CIA: '3ds',
  CCI: '3ds',
  WII: 'wii',
  GC: 'wii',
};

const VIMM_LABEL_ALIASES = {
  Genesis: 'segaMD',
  'Mega Drive': 'segaMD',
  'Sega Genesis': 'segaMD',
  'Super Nintendo': 'snes',
  'Game Boy': 'gb',
  'Game Boy Advance': 'gba',
  'Game Boy Color': 'gb',
  'Master System': 'segaMS',
  'Game Gear': 'segaMS',
  PlayStation: 'psx',
  'Atari 2600': 'atari2600',
  Atari2600: 'atari2600',
  'Nintendo 3DS': '3ds',
  Wii: 'wii',
  GameCube: 'wii',
};

export function vimmToEjsKey(system, systemCode) {
  const code = (systemCode || '').toUpperCase();
  if (VIMM_TO_EJS[code]) return VIMM_TO_EJS[code];
  if (system && VIMM_LABEL_ALIASES[system]) return VIMM_LABEL_ALIASES[system];
  const upper = (system || '').toUpperCase();
  if (VIMM_TO_EJS[upper]) return VIMM_TO_EJS[upper];
  return null;
}

export function consoleLabel(ejsKey, vimmSystem) {
  if (SYSTEMS[ejsKey]) return SYSTEMS[ejsKey].label;
  const ext = { '3ds': 'Nintendo 3DS', wii: 'Nintendo Wii / GameCube' };
  if (ext[ejsKey]) return ext[ejsKey];
  return vimmSystem || ejsKey || 'Outros';
}

export const STORAGE_KEY = 'tom-arcade:lastSystem';

export const EJS_DEFAULT_CONTROLS = {
  0: {
    0: { value: 'x', value2: 'BUTTON_2' },
    1: { value: 's', value2: 'BUTTON_4' },
    2: { value: 'v', value2: 'SELECT' },
    3: { value: 'Enter', value2: 'START' },
    4: { value: 'ArrowUp', value2: 'DPAD_UP' },
    5: { value: 'ArrowDown', value2: 'DPAD_DOWN' },
    6: { value: 'ArrowLeft', value2: 'DPAD_LEFT' },
    7: { value: 'ArrowRight', value2: 'DPAD_RIGHT' },
    8: { value: 'z', value2: 'BUTTON_1' },
    9: { value: 'a', value2: 'BUTTON_3' },
    10: { value: 'q', value2: 'LEFT_TOP_SHOULDER' },
    11: { value: 'e', value2: 'RIGHT_TOP_SHOULDER' },
    12: { value: 'Tab', value2: 'LEFT_BOTTOM_SHOULDER' },
    13: { value: 'r', value2: 'RIGHT_BOTTOM_SHOULDER' },
  },
  1: {},
  2: {},
  3: {},
};
